import { useTranslations } from "../hooks/useTranslations";
import { useMe } from "../http/serviceportalApi";
import DocumentsTab from "./documents/DocumentsTab";
import Alert from "./ui/Alert";
import Page from "./ui/Page";

const EconomicAdvisorDocuments = () => {
  const { i18n } = useTranslations();
  const { data, isValidating } = useMe();
  const luid = data?.economicAdvisor?.luid;

  if (!luid) return null;

  return (
    <Page title={i18n.documents.title} isLoading={isValidating}>
      <Alert showUntil={new Date(2026, 7, 12, 18, 0)}>
        {i18n.documents.maintenanceAlert("12:00", "18:00")}
      </Alert>
      <DocumentsTab luid={luid} archive="payroll" />
    </Page>
  );
};

export default EconomicAdvisorDocuments;
